import React, { lazy, Suspense, useMemo } from "react";

import { useChatsUIContext } from "./context/ChatsContext";
import { ConversationTypeEnum } from "./types/enums";
import Loading from "./components/Loading";
import { conversationTypeList, suggestionList } from "./constants";

const HomeChat = lazy(() => import("./pages/home/HomeChat"));
const ExploreChatPages = lazy(
  () => import("./components/exploreChatPages/ExploreChatPages")
);
const ConversationsPage = lazy(
  () => import("./pages/conversationsPage/ConversationsPage")
);
const GroupChannelMembers = lazy(
  () => import("./pages/groupChannelMembers/GroupChannelMembers")
);

const CreateUpdateGroupChannel = lazy(
  () => import("./pages/createUpdateGroupChannel/CreateUpdateGroupChannel")
);
const SuggestionsPage = lazy(
  () => import("./pages/suggestions/SuggestionsPage")
);

const ChatPage = () => {
  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
    };
  }, [chatsContext?.navigatePage]);

  return (
    <Suspense fallback={<Loading />}>
      {chatsUIProps?.navigatePage?.current === "home" && <HomeChat />}
      {conversationTypeList.includes(chatsUIProps?.navigatePage?.current!) && (
        <ConversationsPage
          isPersonal={
            chatsUIProps?.navigatePage?.current ===
            ConversationTypeEnum.PERSONAL
          }
        />
      )}
      {chatsUIProps?.navigatePage?.current === "create-group" && (
        <CreateUpdateGroupChannel />
      )}
      {chatsUIProps?.navigatePage?.current === "subscribers-list" && (
        <GroupChannelMembers />
      )}
      {chatsUIProps?.navigatePage?.current === "explore-page" && (
        <ExploreChatPages />
      )}
      {suggestionList.includes(chatsUIProps?.navigatePage?.current!) && (
        <SuggestionsPage />
      )}
    </Suspense>
  );
};

export default ChatPage;
